import { gql } from '@apollo/client';

interface AcreditacionProfileFields{
     uuid:number
     name:string
     email:string
     rol:string
}

export enum AcreditacionProfileRol{
    ADMIN='ADMIN'
}


export default class AcreditacionProfile{
    public static getToken= ():string|null =>{
        return sessionStorage.getItem('admin_token')
    }

    public static isLoginIn= ():boolean=>{
        const token = sessionStorage.getItem('admin_token');
        return (token)?true:false;
    }

    public static setToken= (token:string)=>{
        sessionStorage.setItem('admin_token',token)
    };

    public static setProfile= (user:AcreditacionProfileFields)=>{
        sessionStorage.setItem('admin',JSON.stringify(user));
    }

    public static getProfile= ():AcreditacionProfileFields =>{
        let UserJson=sessionStorage.getItem('admin') || '{}';
        return JSON.parse(UserJson);
    };

    public static logOut= ()=>{
        sessionStorage.removeItem('admin_token');
        sessionStorage.removeItem('admin');
    };  
}


export const LOGIN_IN=gql`
    mutation($email:String!,$password:String!){
        loginIn(email:$email,password:$password){
            user{
                id,
                name,
                email,
                is_active,
                rol,
                created_at,
                last_login
            },
            token
        }
  }
`;
